import { type MouseEvent, type KeyboardEvent, type FC, useState } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { TextButton } from "@root/shared/components/TextButton";
import * as styles from "./styles.css";

type Props = {
  matchReasons?: {
    title: string;
    description: string;
  }[];
  className?: string;
};

export const MatchReasons: FC<Props> = ({ matchReasons = [], className }) => {
  const [isVisibleMatchReasons, setIsVisibleMatchReasons] = useState(false);
  const showMatchReasons = () => {
    setIsVisibleMatchReasons(true);
  };

  return (
    <div
      onClick={(e: MouseEvent) => e.preventDefault()}
      onKeyDown={(e: KeyboardEvent<HTMLDivElement>) => e.preventDefault()}
      role="button"
      tabIndex={0}
      className={className ?? ""}
    >
      <GuidanceBox themeColor="pink" className={styles.reasonsOuter}>
        <p className={styles.reasonsHeading}>あなたの希望に沿った求人です！</p>
        {matchReasons.map((reason) => (
          <p key={reason.title} className={styles.reason({ isVisible: isVisibleMatchReasons })}>
            <span>✔︎{reason.title}</span>
            {isVisibleMatchReasons && <>：{reason.description}</>}
          </p>
        ))}
        {!isVisibleMatchReasons && (
          <div className={styles.showReasonsButtonOuter}>
            <TextButton
              size="small"
              className={styles.showReasonsButton}
              onClick={showMatchReasons}
            >
              続きを見る
            </TextButton>
          </div>
        )}
      </GuidanceBox>
    </div>
  );
};
